Ext.define('WindowFirmaPreview', {
    extend: 'Ext.ux.window.WindowExd',
    cls: 'custom-preview-window',
    closable: false,
    collapsible: false,
    modal: true,
    resizable: false,
    scrollable: 'y',
    layout: 'fit',
    initComponent: function () {
        this.items = [{
            type: 'container',
            layout: 'fit',
            anchor: 1,
            items: [{
                id: 'closeWindowMobileBtn',
                type: 'component',
                maxHeight: 60,
                layout: {
                    type: 'hbox',
                    align: 'stretch'
                },
                items: [{
                        xtype: 'container',
                        flex: 1
                    }, {
                        xtype: 'button',
                        iconCls: 'iconX',
                        cls: 'close-window-mobile-btn',
                        width: 50,
                        handler: () => this.closeOp()
                }]
            }, {
                type: 'component',
                layout: {
                    type: 'hbox',
                    align: 'stretch'
                },
                maxHeight: 40,
                items: [{
                    xtype: 'label',
                    flex: 1,
                    text: Lang.firma.capitalise(),
                    align: 'left',
                    cls: 'window-title-mobile'
                }]
            }, {
                type: 'component',
                layout: {
                    type: 'hbox',
                    align: 'stretch'
                },
                maxHeight: 42,
                items: [{
                    xtype: 'label',
                    flex: 1,
                    align: 'left',
                }, {
                    id: this.id + "bedit",
                    xtype: 'button',
                    iconAlign: 'left',
                    iconCls: "iconEdit",
                    ui: 'btn-secondary-s',
                    text: Lang.edytuj.capitalise(),
                    scope: this,
                    disabled: !validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/update"),
                    handler: this.edytujObiekt
                }]
            }, {
                xtype: 'panelmobileobjectpreview',
                itemId: 'mapPanel',
            }]
        }];
        this.callParent(arguments);
    },
    showW: function (obiektid) {
        this.obiektid = obiektid;
        this.obiekt = null;
        this.show();
        this.center();
        this.setKeyMap({
            'ESC': {
                scope: this,
                handler: this.closeOp
            }
        });
        this.mask(Lang.ladowanie);
        performAjaxLPromise('rest/firmy/getObjectForEdit', {id: this.obiektid}).then(data => {
            this.obiekt = data;
            let mapData = {
                [Lang.nazwa]: this.obiekt.nazwa,
                [Lang.identyfikacja_operatora]: TRYB_IDENTYFIKACJI.find(tr => tr[0] == this.obiekt.ident_operator)[1],
                [Lang.identyfikacja_odbiorcy]: TRYB_IDENTYFIKACJI.find(tr => tr[0] == this.obiekt.ident_odbiorca)[1],
                [Lang.identyfikacja_pojazdu]:  TRYB_IDENTYFIKACJI.find(tr => tr[0] == this.obiekt.ident_pojazd)[1],
                [Lang.wymagalnosc_stanu_licznika]: this.obiekt.mustsetlicznikstate ? Lang.tak : Lang.nie,
                [Lang.tankowanie]: this.obiekt.tankowanieoff ? Lang.wylaczone : Lang.wlaczone,
                [Lang.opis]: this.obiekt.opis
            };
            var mapPanel = this.down('#mapPanel');
            mapPanel.loadData(mapData);
            this.manageSelect();
        }).catch(error => {
            handleCommonCallBackAjaxRPCError(error);
        }).finally(() => {
            this.unmask();
        });
    },
    edytujObiekt: function () {
        if (validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/update")) {
            var windowObject = Ext.create('WindowFirma');
            windowObject.showW(this.obiektid);
            windowObject.on('close', function () {
                this.showW(this.obiektid);
            }, this);
        }
    },
    manageSelect: function () {
        var bedit = Ext.getCmp(this.id + "bedit");
        bedit.setDisabled(!validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/update"));
    },
    closeOp: function () {
        this.fireEvent("wclose");
        this.close();
    }
});
